// The Team chat's one count badge (the catalog's CountBadge, which the published Signal DS does not export): the
// number, white on the brand blue, nothing at 0. The words are on the control it sits in.
export function TeamCountBadge({ count }: { count: number }) {
  if (count <= 0) return null;
  return (
    <span className="team-chat-count" data-slot="team-chat-count" aria-hidden>
      {count > 99 ? '99+' : count}
    </span>
  );
}
